// extracted by mini-css-extract-plugin
export default {"inputChangeContainer":"InputRange_inputChangeContainer__u0+RU","value":"InputRange_value__IoDIS"};